import { isNotNull } from '@ricoh/ria.client.core/utils/data/object';

import type {
  DataType,
  DataTypeGeneral,
  DataTypeList,
  DataTypeTable,
  DataValue,
  DataValueGeneral,
  DataValueList,
  DataValueTable,
} from '~/common/model/api/common';

import { DATA_TYPE_GENERAL_NAMES } from '~/common/constants/feature/settings/batch-type-library';
import commonLogic from '~/common/logic/common';

import type { DataTypeFormField, DataTypeFormFieldGeneral, DataTypeFormFieldList, DataTypeFormFieldTable } from './_type.type';
import type { DataValueFormField, DataValueFormFieldTableWithColumns } from './_value.type';

export const TYPE_FORM_FIELD_DEFAULT: DataTypeFormFieldGeneral = {
  type: {
    menuKey: 'text',
    value: 'text',
  },
  format: '',
};

/** Is DataType FormField. */
export const isDataTypeFormField = {
  table: (dataType: DataTypeFormField): dataType is DataTypeFormFieldTable => dataType.type.menuKey === 'table',
  list: (dataType: DataTypeFormField): dataType is DataTypeFormFieldList => dataType.type.menuKey === 'list',
  general: (dataType: DataTypeFormField): dataType is DataTypeFormFieldGeneral => DATA_TYPE_GENERAL_NAMES.includes(dataType.type.menuKey),
};

/** Is DataValue FormField. */
export const isDataValueFormField = {
  tableWithColumns: (dataValue: DataValueFormField<DataType | undefined>): dataValue is DataValueFormFieldTableWithColumns =>
    isNotNull(dataValue) && typeof dataValue === 'object' && 'columns' in dataValue && 'dataItem' in dataValue,
};

/** Is DataType. */
export const isDataType = {
  table: (fieldType: DataType): fieldType is DataTypeTable => fieldType.name === 'table',
  list: (fieldType: DataType): fieldType is DataTypeList => !!commonLogic.type.getListDataType(fieldType.name),
  general: (fieldType: DataType): fieldType is DataTypeGeneral => DATA_TYPE_GENERAL_NAMES.includes(fieldType.name),
};

/** Is DataValue. */
export const isDataValue = {
  table: (fieldValue: DataValue): fieldValue is DataValueTable => fieldValue.type === 'table',
  list: (fieldValue: DataValue): fieldValue is DataValueList => !!commonLogic.type.getListDataType(fieldValue.type),
  general: (fieldValue: DataValue): fieldValue is DataValueGeneral => DATA_TYPE_GENERAL_NAMES.includes(fieldValue.type),
};
